
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";
import cDown from 'helpers/cDown'

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Estudiantes extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_estudiantes();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_estudiantes=()=>{
    console.log("cargar_estudiantes")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
    }
    console.log(param)
    axios2.post("estudiantes_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.length>0){ 
            this.setState({data: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  descargar_csv =()=>{
    //to={process.env.REACT_APP_API_URL  + `/estudiantes_csv/45/1`
    //const href = process.env.REACT_APP_API_URL  + `estudiantes_csv/45/1`
 
    const urlPath = process.env.REACT_APP_API_URL  + `estudiantes_csv/45/1`
    //this.downloadFileCsv(urlPath, "milista.csv")
    cDown.downloadFileCsv(urlPath, "milista.csv")
  }
  //-------------------------------------------
  
  //------------------------------
  render() {
    let materia = this.props.store.materia

    return(
      <div>
        {/* ---   --- */}
        { //JSON.stringify(this.state.form)
        }
        <div className="escritorio center-align p-3">

        <div className="row">
          <div className="col-md-8">
              <h3> Lista de estudiantes.</h3>
              <p>
                  Sigla: { materia.sigla }<br/> 
                  Materia: { materia.nombre } / G{ materia.grupo}
              </p>
          </div>  
          <div className="col-md-4">
            <Button className="btn btn-success"
                onClick={ this. descargar_csv }
            >Exportar</Button>

            
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-bordered ">
            <thead>
              <tr>
                  <th width="80px">Nro</th>
                  <th>C.I.</th>
                  <th>APELLIDOS Y NOMBRES</th>
                  <th>Telf:</th>
                  
              </tr>
            </thead>
            <tbody>
                
                {this.state.data.map((item,index) => ( 
                    <tr key={index}>
                      <td>{ index+1 }</td>
                      <td>{ item.nro_doc }</td>
                      <td>{ item.nomape_tmp }</td>
                      <td>{ item.tel }</td>
                      
                      
                    </tr>
                ))}
                
            </tbody>
          </table>
        </div>
        
        </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(Estudiantes);